// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/gusts-squalls-and-shifts.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/gusts-squalls-and-shifts/gusts-squalls-and-shifts.js';

mount([g0]);
